import { DashboardMockApi } from './dashboards/api';

export const mockApiServices = [DashboardMockApi];
